export default __webpack_public_path__ + "static/media/mainFlowersCollectionBG.45ef7154.png";